import { prepareQPFromFilters, serverAxios } from 'utils/http';
import { AxiosResponse } from 'axios';
import {
  ICreateSettingsTemplate,
  ICreateSettingsTemplateResponse,
  IDeleteSettingsTemplateResponse,
  IGetSettingsTemplateFilters,
} from 'models/http/settingsTemplates';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { IGetSimpleListResponse } from 'models/http/common';
import { SettingsTemplatesType } from 'utils/enums/settings';

class SettingsTemplatesHttp {
  private static route = '/settingsTemplates';

  public async getSimple(filters?: IGetSettingsTemplateFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    const queryParams = prepareQPFromFilters({ type: filters?.type });

    return serverAxios
      .get(`${SettingsTemplatesHttp.route}/simple?${queryParams.toString()}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateSettingsTemplate): Promise<ICreateSettingsTemplateResponse> {
    return serverAxios
      .post(SettingsTemplatesHttp.route, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateSettingsTemplateResponse>) => {
        return response.data;
      });
  }

  public async deleteById(id: number, type: SettingsTemplatesType): Promise<IDeleteSettingsTemplateResponse> {
    return serverAxios
      .delete(SettingsTemplatesHttp.route, {
        data: { id, type },
        timeout: HttpTimeoutPriority.Low,
      })
      .then();
  }
}

export default SettingsTemplatesHttp;
